<template>
  <div id="app">
    <the-header ref="theHeader" />
    <main class="app-container" :style="{ 'margin-top': headerHeight }">
      <router-view class="app-container__view" />
    </main>
    <search-button v-if="isSearchButtonVisible" />
    <the-footer />
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import { GET_DEALER_MICRO_SITE } from "@/store/actionTypes";
import TheHeader from "@/components/layout/TheHeader/TheHeader.vue";
import TheFooter from "@/components/layout/TheFooter/TheFooter.vue";
import SearchButton from "@/components/search/SearchButton/SearchButton.vue";

export default {
  metaInfo() {
    return {
      titleTemplate: this.isDealerMicroSite
        ? this.$t("meta-info.title.dealerTemplate", {
          dealerName: this.dealerName
        })
        : this.$t("meta-info.title.baseTemplate")
    };
  },
  components: {
    TheHeader,
    TheFooter,
    SearchButton
  },
  data() {
    return {
      headerHeight: 0
    };
  },
  computed: {
    ...mapGetters(["isDealerMicroSite", "dealerName"]),
    isSearchButtonVisible() {
      return (
        this.$route.name === "search" || this.$route.name === "dealerSearch"
      );
    }
  },
  async created() {
    await this.$store.dispatch(GET_DEALER_MICRO_SITE);
  },
  mounted() {
    this.setHeaderHeight();
    window.addEventListener("resize", this.setHeaderHeight);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.setHeaderHeight);
  },
  methods: {
    setHeaderHeight() {
      this.headerHeight = `${this.$refs.theHeader.$el.clientHeight}px`;
    }
  }
};
</script>

<style lang="scss" scoped>
#app {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.app-container {
  flex: 1 auto;
}

@media screen and (min-width: $media-xl) {
  .app-container {
    @include grid-columns(12);

    &__view {
      @include grid-columns-from-to(2, 12);
    }
  }
}
</style>
